import React, { useState } from "react";
import Modal from "react-responsive-modal";
import ButtonSpinner from "./ButtonSpinner";

const LogoutModal = ({ open, onClose, onLogout, modalClassName, contentClassName, actionsClassName, confirmBtnClassName }) => {
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = () => {
    setLoggingOut(true);
    onLogout();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      center
      classNames={modalClassName ? { modal: modalClassName } : undefined}
    >
      <div className={`${contentClassName || ""} p-4 text-center`}>
        <h4 className="uk-text-bold mb-3">Confirm Logout</h4>
        <p className="mb-4">Are you sure you want to log out?</p>
        <div
          className={actionsClassName || "d-flex justify-content-center"}
          style={actionsClassName ? undefined : { gap: "10px" }}
        >
          <button
            className="uk-button uk-button-default text-uppercase"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className={`uk-button uk-button-default text-uppercase ${confirmBtnClassName || ""}`}
            onClick={handleLogout}
            disabled={loggingOut}
          >
            {loggingOut ? <ButtonSpinner color="#000" /> : "Log Out"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LogoutModal;
